const CONFIRM_STYLES = {
  danger:  'border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300',
  neutral: 'border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300',
};

const ConfirmModal = ({ message, confirmLabel = 'Delete', variant = 'danger', onConfirm, onCancel }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div className="absolute inset-0 bg-black/30" onClick={onCancel} />
    <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-6 max-w-sm w-full">
      <p className="text-gray-800 text-sm text-center mb-6">{message}</p>
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="flex-1 py-2.5 text-sm font-medium rounded-lg border border-gray-200 text-gray-600 hover:border-gray-300 hover:text-gray-800 transition bg-white"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className={`flex-1 py-2.5 text-sm font-medium rounded-lg border transition bg-white ${CONFIRM_STYLES[variant] ?? CONFIRM_STYLES.danger}`}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
